export const black = {
  950: "#000",
};

export const white = {
  50: "#FFFFFF",
};

export const gray = {
  50: "#F5F6F6",
  100: "#EBECED",
  200: "#D7D9DA",
  300: "#B5B8BA",
  400: "#9CA1A3",
  500: "#8B9093",
  600: "#686F73",
  700: "#485056",
  800: "#394248",
  900: "#141F25",
  950: "#08131A",
};

export const yellow = {
  50: "#FFFFE7",
  100: "#FEFFC1",
  200: "#FFFC86",
  300: "#FFF241",
  400: "#FFE30D",
  500: "#FFD400",
  600: "#D19C00",
  700: "#A66F02",
  800: "#89560A",
  900: "#74470F",
  950: "#442504",
};

export const violet = {
  50: "#F4F1FF",
  100: "#EBE6FF",
  200: "#D9D0FF",
  300: "#BDABFF",
  400: "#9E7BFF",
  500: "#8146FF",
  600: "#7320FF",
  700: "#6D1AF3",
  800: "#550CCB",
  900: "#470CA6",
  950: "#290471",
};

// TODO: define
export const green = {
  300: "#00EE88",
  500: "#1CA47F",
};

// TODO: define
export const red = {
  100: "#FFE1E1",
  500: "#DC0000",
};
